module.exports = new __parcel__URL__("boss_fight_button_text.5b83c8f5.png").toString();